import { ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import { AbstractFormComponent, FieldDateComponent, FieldNumberComponent, FieldSelectComponent, FieldTextAreaComponent, FieldTextComponent, FieldWrapperComponent } from '@spike/scaffolds';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';
import { WalletListComponent } from '../../components/wallet-list/wallet-list';
import { map, startWith, switchMap } from 'rxjs';
import { toObservable, toSignal } from '@angular/core/rxjs-interop'; // Importante per la reattività
import { InputNumber} from 'primeng/inputnumber';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-investment-form',
  providers:[],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputNumber, FieldTextComponent, FieldDateComponent, FieldSelectComponent, FieldNumberComponent, WalletListComponent, FieldTextAreaComponent, FieldWrapperComponent],
  templateUrl: './investment-form.html'
})

export class InvestmentFormComponent extends AbstractFormComponent{
    public readonly walletStoreService = inject(WalletStoreService);
    public readonly investmentType = input.required<number>();


    private readonly formValues = toSignal(
      toObservable(this.form).pipe(
        switchMap(form => form.valueChanges.pipe(
          startWith(form.getRawValue())
        ))
      )
    );

    public readonly totalValue = computed(() => {
        const { quantity, purchaseValue, commissionCost } = this.formValues();
        
        if (this.investmentType() === 3) {
            return purchaseValue - commissionCost;
        }else if (this.investmentType() === 1) {
            return -Math.abs(purchaseValue*quantity) - commissionCost;
        }else if(this.investmentType() === 2) {
            return Math.abs(purchaseValue*quantity) - commissionCost;
        }
        else return 0;
    });
}


  

